import {
    HomeDemo1Platforms1,
    HomeDemo1Platforms2,
    HomeDemo1Platforms3,
    HomeDemo1Platforms4,
    HomeDemo1Platforms5,
    HomeDemo1Platforms6,

    HomeDemo1Feature1,
    HomeDemo1Feature2,
    HomeDemo1Feature3,
    HomeDemo1Feature4,
    HomeDemo1Feature5,
    HomeDemo1Feature6,
    HomeDemo1Feature7,
    HomeDemo1Feature8,

    HomeDemo1FeaturesS1,
    HomeDemo1FeaturesS2,
    HomeDemo1FeaturesS3,
    HomeDemo1FeaturesS4,

    HomeDemo1FeaturesF1,
    HomeDemo1FeaturesF2,
    HomeDemo1FeaturesF3,
    HomeDemo1FeaturesF4,
    HomeDemo1FeaturesF5,
    HomeDemo1FeaturesF6,

    HomeDemo1TeamImg1,
    HomeDemo1TeamImg2,
    HomeDemo1TeamImg3,
    HomeDemo1TeamImg4,

    HomeDemo1BlogImg1,
    HomeDemo1BlogImg2,
    HomeDemo1BlogImg3,
    HomeDemo1TeamImg5,
    HomeDemo1TeamImg6,
    HomeDemo1TeamImg7,
    HomeDemo1TeamImg8,
    HomeDemo1TeamImg9,
    HomeDemo1TeamImg10,
    HomeDemo1TeamImg11,
    HomeDemo1TeamImg12,
    HomeDemo1TeamImg13,
    HomeDemo1TeamImg14,
    HomeDemo1TeamImg15,

} from '../../../utils/allImgs'

export const SecTrustContent = [
    {
        img: HomeDemo1Platforms1,
        CheckIcon: true
    },
    {
        img: HomeDemo1Platforms2,
        value: 8.9,
        CheckIcon: false
    },
    {
        img: HomeDemo1Platforms3,
        CheckIcon: true
    },
    {
        img: HomeDemo1Platforms4,
        CheckIcon: true
    },
    {
        img: HomeDemo1Platforms5,
        value: 7.4,
        CheckIcon: false
    },
    {
        img: HomeDemo1Platforms6,
        CheckIcon: true
    },
]

export const Services = [
    {
        img: HomeDemo1Feature1,
        title: "Public Distribution",
        description: "Initial We distribute 40% of tokens to the Public."
    },
    {
        img: HomeDemo1Feature4,
        title: "Eco System Development",
        description: "In the future, we are planning to create one combined place for content creators so we use a 15% token supply to build an eco system."

    },
    {
        img: HomeDemo1Feature2,
        title: "Community",
        description: "We use our token to increase and support the content creator community."

    },
    {
        img: HomeDemo1Feature3,
        title: "Marketing",
        description: "Python is the Native token for Cryptonium and Horizon so we will use token 10% token to market this product."

    },
    {
        img: HomeDemo1Feature8,
        title: "Blockchain Development",
        description: "In the future, we plan to launch our own blockchain where we use the token supply of eco-system development."

    },
    {
        img: HomeDemo1Feature7,
        title: "Presale",
        description: "Our aim is to use a 10% token supply in Presale Before ICO Event."

    },
    {
        img: HomeDemo1Feature6,
        title: "Liquidity Pool",
        description: "We will lock liquidity into quick-swap where we lock 15% token supply."

    },
    {
        img: HomeDemo1Feature5,
        title: "Referral",
        description: "In the Avatar generation game, we run referral and affiliate programs so we will use a 5% token for the referral program."
    },
]

export const SmartContractinfo = [
    {
        img: HomeDemo1FeaturesS1,
        title: "Cycles and schedules"

    },
    {
        img: HomeDemo1FeaturesS2,
        title: "Advanced application interface (API)"

    },
    {
        img: HomeDemo1FeaturesS3,
        title: "Software development kit (SDK)"

    },
    {
        img: HomeDemo1FeaturesS4,
        title: "Java virtual machine (JVM)"

    },
]

export const Features2InfoTop = [
    {
        img: HomeDemo1FeaturesF1,
        title: "Delivery Reports"
    },
    {
        img: HomeDemo1FeaturesF2,
        title: "Branded Sender"
    },
    {
        img: HomeDemo1FeaturesF3,
        title: "SMS Messaging"
    }
]

export const Features2InfoDown = [
    {
        img: HomeDemo1FeaturesF4,
        title: "Marketing Plans"
    },
    {
        img: HomeDemo1FeaturesF5,
        title: "Seed Routing"
    },
    {
        img: HomeDemo1FeaturesF6,
        title: "Traking API"
    }
]

export const OurTeamInfo = [
    {
        img: HomeDemo1TeamImg1,
        title: "Arpit Lukhi",
        text: "Founder of Horizon"
    },
    {
        img: HomeDemo1TeamImg2,
        title: "Mehul Kalathiya",
        text: "Project Manager"
    },
    {
        img: HomeDemo1TeamImg3,
        title: "Hitesh Patel",
        text: "Super Investors"
    },
    {
        img: HomeDemo1TeamImg4,
        title: "Divyang Patel",
        text: "Business Analyst at Horizon"
    },
    {
        img: HomeDemo1TeamImg6,
        title: "Nihar Thummar",
        text: "Marketing Lead At Cryptonium"
    },
    {
        img: HomeDemo1TeamImg7,
        title: "Priyanshu Vijay",
        text: "Senior Solidity Developer"
    },
    {
        img: HomeDemo1TeamImg8,
        title: "Ratneshwar Kumar",
        text: "Senior Solidity Developer"
    },
    {
        img: HomeDemo1TeamImg9,
        title: "Keval Sabhani",
        text: "Senior FullStack Developer"
    },
    {
        img: HomeDemo1TeamImg5,
        title: "Siddharth Patel",
        text: "FullStack Developer"
    },
    {
        img: HomeDemo1TeamImg10,
        title: "Ravi Radadiya",
        text: "Senior Backend Developer"
    },
    {
        img: HomeDemo1TeamImg11,
        title: "Yash Patel",
        text: "Senior FullStack Developer"
    },
    {
        img: HomeDemo1TeamImg12,
        title: "Naman Thaker",
        text: "Solidity Developer"
    },
    {
        img: HomeDemo1TeamImg13,
        title: "Masiha Ansari",
        text: "Web Developer"
    },
    {
        img: HomeDemo1TeamImg14,
        title: "Jay Rathod",
        text: "Web Developer"
    },
    {
        img: HomeDemo1TeamImg15,
        title: "Vedant Parmar",
        text: "Web Developer"
    }
]

export const OurBlogInfo = [
    {
        img: HomeDemo1BlogImg1,
        title: "What is this Token for?."
    },
    {
        img: HomeDemo1BlogImg2,
        title: "The most powerful Token"
    },
    {
        img: HomeDemo1BlogImg3,
        title: "How to get trial version"
    }
]